import { RouteConfig } from 'vue-router'

const Index = () => import('./match-system-landing/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/2026-match-system-landing',
  name: 'activity_match_system_landing',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '校园运动会管理系统',
    ignoreLogin: true,
  },
}

export default [indexRoute]
